<template>
    <div class="question">
        <span v-for="(option,index) in message.options.responses" :key="index">
            <button @click="chooseResponse(option)" v-html=option.label></button>
        </span>
    </div>
</template>

<script>
import { Message } from '@/bot-engine.es5.js';
import showdown from 'showdown'

export default {
    name: 'Question',
    props: {
        message: {
            type: Message
        }
    },
    data() {
        return {
          converter: new showdown.Converter()
        }
    },
    methods: {
        chooseResponse(option) {
            this.$emit('selected', option);
        }
    // markdown
    }
}
</script>

<style scoped>
    @keyframes fromright {
        0%   {left:200%; top:0px;}
        90%  {left:10%; top:0px;}
        100% {left:0px; top:0px;}
    }

    .question {
        animation-name: fromright;
        animation-duration: 1s;
        animation-timing-function: ease-in-out;
        position: relative;
    }
</style>
